import { render, staticRenderFns } from "./TablesStatsTable.vue?vue&type=template&id=6880d187&scoped=true&"
import script from "./TablesStatsTable.vue?vue&type=script&lang=js&"
export * from "./TablesStatsTable.vue?vue&type=script&lang=js&"
import style1 from "./TablesStatsTable.vue?vue&type=style&index=1&id=6880d187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6880d187",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDataTable,VDialog})
